import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Radio,
} from '@mui/material';

function BancoSelectionDialog({ open, onClose, bancos, onConfirm }) {
  const [selectedBanco, setSelectedBanco] = useState(null);

  useEffect(() => {
    if (open) {
      const preferencial = bancos.find((b) => b.is_preferencial);
      const fallback = bancos[0];
      setSelectedBanco(preferencial?.id || fallback?.id || null);
    }
  }, [open, bancos]);

  const handleConfirm = () => {
    if (selectedBanco) {
      onConfirm(selectedBanco);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Selecione um Banco</DialogTitle>
      <DialogContent>
        <List>
          {bancos.map((banco) => (
            <ListItem
              key={banco.id}
              button
              onClick={() => setSelectedBanco(banco.id)}
            >
              <ListItemIcon>
                <Radio checked={selectedBanco === banco.id} />
              </ListItemIcon>
              <ListItemText primary={banco.nome} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={!selectedBanco}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default BancoSelectionDialog;
